/**
 * Legal identity of the operator, shown in every public footer (the landing
 * page and the server-rendered content site) and in the Organization JSON-LD.
 * One source so the address, tax and registry numbers never drift between
 * surfaces. The badge images live under apps/web/public/img and are served by
 * the web origin, so the paths work on the API-rendered pages too.
 */
export interface CertificationBadge {
  readonly src: string;
  readonly alt: string;
  readonly width: number;
  readonly height: number;
}

/** One certificate: its marks, linked to the TÜRKAK verification page. */
export interface Certification {
  readonly verifyUrl: string;
  readonly badges: readonly CertificationBadge[];
}

export const COMPANY = {
  legalName: "Marsala Yazılım A.Ş.",
  /** Registered office ("Merkez"), one display line per entry. */
  hqLines: [
    "Bilişim Vadisi İzmir,",
    "Gülbahçe Mh. İçmeler Cad. No: 14/1",
    "İç Kapı No: B05 Urla - İZMİR/TÜRKİYE",
  ],
  /** Display form for the footer; `phoneE164` feeds the tel: link and JSON-LD. */
  phone: "0532 206 4360",
  phoneE164: "+905322064360",
  addressLocality: "Urla",
  addressRegion: "İzmir",
  addressCountry: "TR",
  taxOffice: "Urla",
  taxNumber: "6121748678",
  mersisNo: "0612174867800001",
  certifications: [
    {
      verifyUrl: "https://asist.turkak.org.tr/tr/document-verification/4f32db77-645a-4bc7-9293-08deb4af5d1b",
      badges: [
        {
          src: "/img/certs/iso27001-proks.webp",
          alt: "ISO/IEC 27001 Certified — PROKS Certification",
          width: 234,
          height: 260,
        },
        {
          src: "/img/certs/iso27001-turkak.webp",
          alt: "TÜRKAK — Bilgi Güvenliği Y.S. TS EN ISO/IEC 17021, AB-0111-YS",
          width: 180,
          height: 260,
        },
      ],
    },
    {
      verifyUrl: "https://asist.turkak.org.tr/tr/document-verification/a3e9e8b3-371d-4ae8-4a17-08df1f7ec690",
      badges: [
        {
          src: "/img/certs/iso42001-proks.webp",
          alt: "ISO/IEC 42001 Certified — PROKS Certification",
          width: 234,
          height: 260,
        },
        {
          src: "/img/certs/iso42001-turkak.webp",
          alt: "TÜRKAK — Yapay Zeka Y.S. TS EN ISO/IEC 42001, AB-0111-YS",
          width: 180,
          height: 260,
        },
      ],
    },
  ] satisfies readonly Certification[],
} as const;
